import { Component, Input } from '@angular/core';
import {
  VakiSiteId,
  Image,
  LOGO_WHITE,
  VakiSites
} from '@vaki/shared/util/interfaces';
import { RouterModule } from '@angular/router';
import { NgIf } from '@angular/common';

@Component({
  selector: 'lib-vakers-shell-ui-toolbar-logo',
  imports: [RouterModule, NgIf],
  templateUrl: './vakers-shell-ui-toolbar-logo.component.html',
  styleUrl: './vakers-shell-ui-toolbar-logo.component.scss'
})
export class VakersShellUiToolbarLogoComponent {
  @Input() isVakiSite: boolean | null | undefined;
  @Input() logo: Image | undefined | null;
  @Input() siteLogo: Image | undefined | null;
  @Input() siteId: VakiSiteId | null | undefined;
  LOGO_VAKI_WHITE = LOGO_WHITE;
  getHomeUrl() {
    if (this.siteId === VakiSites.VAKI) {
      return '/';
    } else {
      return '/' + this.siteId;
    }
  }
}
